<template>
  <div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--title-color)
}

.what-does-each-status-mean-section {
  padding-top: 30px;
}

.what-does-each-status-mean-body {
  text-align: left;
}

.nav-link.active {
  color: black !important;
}

a {
  color: #136FC2 !important;
}

.nav-link {
  color: #136FC2 !important;
}
 
@font-face {
  font-family: "KiaSignatureBold";
  src: local("KiaSignatureBold"),
    url('./fonts/KiaSignatureBold.ttf') format("truetype");
}

@font-face {
  font-family: "KiaSignatureLight";
  src: local("KiaSignatureLight"),
    url('./fonts/KiaSignatureLight.ttf') format("truetype");
}

@font-face {
  font-family: "KiaSignatureRegular";
  src: local("KiaSignatureRegular"),
    url('./fonts/KiaSignatureRegular.ttf') format("truetype");
}
</style>
